import { Snackbar, SnackbarProps } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { AxiosError } from 'axios';
import * as React from 'react';
import { SharedService } from './services/shared.service';

class AppErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {

	public static getDerivedStateFromError = (error: Error) => {
		return { hasError: true }
	};
	
	constructor(props: IErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false, errorMessage: '' };
	}

    public componentDidMount() {
        // Add an event listener to the window to catch unhandled promise rejections & stash the error in the state
        window.addEventListener('unhandledrejection', this.handleUnhandledRejection)
    }

    public componentDidUpdate() {
		if (this.state.hasError) {
			this.setState({ hasError: false });
		}
    }

    public componentWillUnmount() {
        window.removeEventListener('unhandledrejection', this.handleUnhandledRejection);
    }

	public componentDidCatch(error: any) {
		this.handleUnhandledRejection(error);
	}

	public render() {
		return (
            <>
                {this.props.children}
                <Snackbar open={!!this.state.errorMessage} autoHideDuration={6000} onClose={() => this.setState({
                    errorMessage: ''
                })}>
					<Alert severity='error'>{this.state.errorMessage}</Alert>
				</Snackbar>
            </>
        );
	}

	private handleUnhandledRejection = (e: PromiseRejectionEvent) => {
		const axiosError = (e.reason || e) as AxiosError;
		if (axiosError?.isAxiosError) {
            const sharedService = new SharedService();
			const errorMessage = sharedService.parseAxiosError(axiosError);
			this.setState({ hasError: true, errorMessage });
		}
	}
}

// tslint:disable-next-line: no-empty-interface
interface IErrorBoundaryProps extends SnackbarProps {}

interface IErrorBoundaryState {
	hasError: boolean;
	errorMessage: string;
}

export default AppErrorBoundary;
